import React, { useCallback, useEffect, useState } from 'react';
import { work_spaceActions, workspace_userActions, notificationActions } from '../../../actions';
import { connect, useDispatch } from 'react-redux';
import { adminBaseURL } from '../../../utils/commonUtils';
import { UserAvatar, ReminderAvatar, useInterval } from '../../../components';
import { renderNameAndSummary, renderDueNotificationSummary } from '../../../utils';
import { Button } from 'react-bootstrap';
import { CONTENT_GROUP_ACTION } from '../../../constants';

function NotificationRow(props) {
  const dispatch = useDispatch();
  const { mode, className, key, notification_load, noName } = props;
  const { data, setWorkspaceId, setContentGroupPopUp, setHighlightedComment, currentUser } = props;
  const workspaceBaseUrl = adminBaseURL("workspaces");
  const [isRead, setIsRead] = useState(data ? data.is_read : false);
  const readable = props.readable ? !isRead : false;

  useEffect(() => {
    if(data){
      setIsRead(data.is_read)
    }
  }, [data]);

  useEffect(() => {
    if (notification_load && notification_load.id === data.id && props.readable) {
      setIsRead(notification_load.is_read)
    }
  }, [notification_load]);

  const contentClickHandler = (e) => {
    const targetLink = e.target.closest('a');
    if(!targetLink) return;
    e.preventDefault();
    var content_id = targetLink.getAttribute("data-contentId")
    var workspace_id = targetLink.getAttribute("data-workspaceId")
    var comment_id = targetLink.getAttribute("data-commentId")
    var internal = targetLink.getAttribute("data-internal")
    var cg_id = targetLink.getAttribute("data-commentCgId")
    sessionStorage.setItem("previous_url", window.location.pathname)

    dispatch({type: CONTENT_GROUP_ACTION.CLOSE_CARD_MODAL});

    setTimeout(() => { 
      dispatch({ type: CONTENT_GROUP_ACTION.SET_HIGHLIGHTED_COMMENT, payload: { id: comment_id, internal: internal, cg_id: cg_id } });
      dispatch({ type: CONTENT_GROUP_ACTION.OPEN_CARD_MODAL, payload: { id: content_id, workspace_id: workspace_id } });
    }, 500);
    return true
  }

  const handleRead = (notificationId) => {
    dispatch(notificationActions.read(notificationId));
  }

  const handleUnRead = (notificationId) => {
    dispatch(notificationActions.unRead(notificationId));
  }

  const workspaceClickHandler = (e, data) =>{
    e.stopPropagation();

    window.location = `/organizations/${data.organization_id}${workspaceBaseUrl}/${data?.workspace_id}/list`

    return true;
  }

  const activityDescriptionHtml = () => {
    const bold_name = mode === 'notification';

    if(data?.notification_type === 'due_reminder'){
      return renderDueNotificationSummary(data)
    }

    if(data?.notification_type === 'removed_from_workspace' && 
      data?.actor?.user_id === data?.user_id
    ){
      return data.summary
    }

    return renderNameAndSummary(data?.actor?.name, data?.summary, bold_name, shouldDisplayNameAndActivityInOneLine());
  }

  const shouldDisplayNameAndActivityInOneLine = () => {
    if(noName) return !noName;

    return true;
  }

  const handleAcceptInvitation = (e, data) => {
    e.preventDefault();
    e.stopPropagation();

    const {
      workspace_id, 
      id: notification_id, 
      resource_id:id 
    } = data;

    dispatch(workspace_userActions.acceptInvitation(workspace_id, id, notification_id))
  }

  const handleDeclineInvitation = (e, data) => {
    e.preventDefault();
    e.stopPropagation();

    const {
      workspace_id, 
      id: notification_id, 
      resource_id:id 
    } = data;

    dispatch(workspace_userActions.declineInvitation(workspace_id, id, notification_id))
  }
  
    const renderInvitationButton = useCallback((data) => {
      if(data.notification_type !== "new_workspace_invite" ) return;
  
      const { status } = data.parsed_notification_data;
  
      if (status === 'accepted') {
        return (
          <div className="d-flex" style={{ marginTop: '6px', marginBottom: '6px' }}>
            <Button className='disabled'>Accepted</Button>
          </div>
        )
      } else if ( status === 'declined' ) {
        return (
          <div className="d-flex" style={{ marginTop: '6px', marginBottom: '6px' }}>
            <Button variant='secondary' className='disabled'>Declined</Button>
          </div>
        )
      } else {
        return (
          <div className="d-flex" style={{ marginTop: '6px', marginBottom: '6px' }}>
            <Button className='me-3' onClick={(e) => handleAcceptInvitation(e, data)}>Accept</Button>
            <Button variant='secondary' className='' onClick={(e) => handleDeclineInvitation(e, data)}>Decline</Button>
          </div>
        )
      }
    }, [])

  return (
    <div onClick={() => props.readable ? (isRead ? handleUnRead(data.id) : handleRead(data.id)) : null }>
      <div className={`${readable ? (isRead ? 'notifications read_message' : 'notifications unread_message') : 'notifications read_message' } ${className}`} onClick={contentClickHandler}>
        <div className="d-flex notification-info_container">
          {
            (data?.notification_type === 'due_reminder' || data?.notification_type === 'past_due_reminder') ?
              <div className="notification__image-wrapper">
                <ReminderAvatar due_date={data?.due_date} past_due={data?.notification_type === 'past_due_reminder'}/>
              </div>
            :
              (data?.actor?.icon || data?.actor?.name_initials) &&
                <div className="notification__image-wrapper">
                  <UserAvatar
                    icon={ data.actor.icon }
                    name={ data.actor.name }
                    name_initials={ data.actor.name_initials }
                    size="30"
                    user_id={data.actor.user_id}
                    workspace_id={ data.workspace_id }
                    organization_id={ data.organization_id }
                    openUserSummary={true}
                  />
                </div>

          }

          <div className="notification-description_container">
            { false &&
              <p className="notification__actor-name">{data.actor.name}</p>
            }

            <div className="notification__description" dangerouslySetInnerHTML={{ __html: activityDescriptionHtml() }} />
            {
              renderInvitationButton(data)
            }
            <div className="notifications-dropdown__notification-timestamp" title={ data.created_at_readable }>
              <span className="mr-3">
                { data.created_at_time_from_now }
              </span>
              <span className="workspace_link" onClick={(e) => workspaceClickHandler(e, data)}>
                { data.workspace_name }
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    currentUser: state.dashboard.currentUser,
    notification_load: state.notification.notification_load
  };
};

export default connect(mapStateToProps, {})(NotificationRow);
